import { useUnit } from 'effector-react';
import { useEffect } from 'react';
import { $chHexagons } from '../../../models/centerHomeModel/index.js';
import { $mapLoaded } from '../../../models/mapModel/index.js';
import { $gradientBuckets } from '../../../models/gradientModel/index.js';
import { formDynamicBuckets } from '../../../utils/hexagon-utils.js';

function ChHexagons() {
  const hexagons = useUnit($chHexagons);
  const mapLoaded = useUnit($mapLoaded);
  const { buckets, colors } = useUnit($gradientBuckets);

  const createLayer = (update) => {
    const chHexagonsData = {
      type: 'FeatureCollection',
      features: hexagons.filter((item) => item.properties.index_main),
    };
    const gradientProp = formDynamicBuckets(buckets, colors, 'index');

    if (update) {
      window.map.getSource('ch_hexagons_source').setData(chHexagonsData);
      window.map.setPaintProperty(
        'ch_hexagons_layer',
        'fill-extrusion-color',
        gradientProp
      );
      window.map.setPaintProperty(
        'ch_hexagons_outline_layer',
        'line-color',
        gradientProp
      );
    } else {
      if (!window.map.getSource('ch_hexagons_source')) {
        window.map.addSource('ch_hexagons_source', {
          type: 'geojson',
          data: chHexagonsData,
        });
      }

      if (!window.map.getLayer('ch_hexagons_layer')) {
        window.map.addLayer({
          id: 'ch_hexagons_layer',
          type: 'fill-extrusion',
          source: 'ch_hexagons_source',
          paint: {
            'fill-extrusion-color': gradientProp,
            'fill-extrusion-opacity': 0.5,
            'fill-extrusion-height': 0,
          },
        });

        window.map.addLayer({
          id: 'ch_hexagons_outline_layer',
          type: 'line',
          source: 'ch_hexagons_source',
          paint: {
            'line-color': gradientProp,
            'line-width': 1,
            'line-opacity': 0.8,
          },
        });
      }
    }
  };

  useEffect(() => {
    if (mapLoaded && hexagons) {
      if (window.map.getLayer('ch_hexagons_layer')) {
        createLayer(true);
      } else {
        setTimeout(() => {
          createLayer(false);
        }, 500);
      }
    }
  }, [mapLoaded, hexagons, buckets]);

  return null;
}

export default ChHexagons;
